import { initReactI18next } from 'react-i18next';
import i18n from 'i18next';
import Backend from 'i18next-http-backend';

import {
  DEFAULT_LANGUAGE,
  detectLanguage,
  persistLanguage,
  SUPPORTED_LANGUAGES,
} from './lib/language';

i18n
  .use(Backend)
  .use(initReactI18next)
  .init({
    lng: detectLanguage(),
    fallbackLng: DEFAULT_LANGUAGE,
    preload: [...SUPPORTED_LANGUAGES],
    supportedLngs: [...SUPPORTED_LANGUAGES],
  });

i18n.on('languageChanged', (lng) => {
  persistLanguage(lng);
  document.documentElement.lang = lng.split('-')[0];
});

export default i18n;
